import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAccountSetupAllowedPath } from '../utils/accountSetup';

interface AccountSetupGateProps {
  children: React.ReactNode;
}

/**
 * Soft gate: incomplete employee profiles may only use profile and governance until HR completes setup.
 */
export default function AccountSetupGate({ children }: AccountSetupGateProps) {
  const { profileSetupStatus } = useAuth();
  const location = useLocation();

  if (!profileSetupStatus?.isRestricted) {
    return <>{children}</>;
  }

  if (isAccountSetupAllowedPath(location.pathname)) {
    return <>{children}</>;
  }

  return <Navigate to="/profile" replace state={{ accountSetupRedirectFrom: location.pathname }} />;
}
